import React from 'react';

export default function Graph57(props) {

    let {a, b, c, n, m} = props.data;
    
    props.board.create('functiongraph',[function(x){return a*Math.abs(x - n) + b*Math.abs(x - m) + c*x}],{strokeColor:'black',highlightStrokeColor:'black'});
    
    return <></>
}